var render = function render(){var _vm=this,_c=_vm._self._c;return _c('count-to',{attrs:{"start-val":_vm.startValue,"end-val":Number(this.endVal || 0),"duration":_vm.duration,"decimals":_vm.decimals,"separator":_vm.separator}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }